"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return new Date().toISOString().slice(0, 10);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/todayUTCString.js
// module id = 77
// module chunks = 0